const col = (key, label, { conditionallyRequired = false, required = false } = {}) => ({
    key,
    label,
    required,
    conditionallyRequired,
});

export const ITEM_MASTER_COLUMN_DEFS = [
    col('action', 'Action', { required: true }),
    col('externalSku', 'External SKU', { conditionallyRequired: true }),
    col('internalName', 'Internal Name', { conditionallyRequired: true }),
    col('brand', 'Brand', { conditionallyRequired: true }),
    col('basePrice', 'Base Price', { conditionallyRequired: true }),
    col('categoryOne', 'Item Category One'),
    col('categoryTwo', 'Item Category Two'),
    col('categoryThree', 'Item Category Three', { conditionallyRequired: true }),
    col('categoryFour', 'Item Category Four', { conditionallyRequired: true }),
    col('sellableUnitsPerCase', 'Sellable Units Per Case', { conditionallyRequired: true }),
    col('purchasingCaseUOM', 'Purchasing Case UOM', { conditionallyRequired: true }),
    col('casesPerPallet', 'Cases Per Pallet', { conditionallyRequired: true }),
    col('poundsPerCase', 'Pounds Per Case', { conditionallyRequired: true }),
    col('portionCount', 'Portion Count', { conditionallyRequired: true }),
    col('replenishment', 'Replenishment'),
    col('hi', 'HI', { conditionallyRequired: true }),
    col('ti', 'TI', { conditionallyRequired: true }),
    col('vendorGuaranteedDays', 'Vendor Guaranteed Days', { conditionallyRequired: true }),
    col('unitLengthIn', 'Unit Length (in)', { conditionallyRequired: true }),
    col('unitWidthIn', 'Unit Width (in)', { conditionallyRequired: true }),
    col('unitHeightIn', 'Unit Height (in)', { conditionallyRequired: true }),
    col('caseLengthIn', 'Case Length (in)', { conditionallyRequired: true }),
    col('caseWidthIn', 'Case Width (in)', { conditionallyRequired: true }),
    col('caseHeightIn', 'Case Height (in)', { conditionallyRequired: true }),
    col('receivingTempZone', 'Receiving Temp Zone', { conditionallyRequired: true }),
    col('storageTempZone', 'Storage Temp Zone', { conditionallyRequired: true }),
    col('carrierShippingTempZone', 'Carrier Shipping Temp Zone', { conditionallyRequired: true }),
    col('dbiShippingTempZone', 'DBI Shipping Temp Zone', { conditionallyRequired: true }),
    col('sellableUnitUOM', 'Sellable Unit UOM', { conditionallyRequired: true }),
    col('sellableUnitSize', 'Sellable Unit Size', { conditionallyRequired: true }),
    col('skuDateType', 'SKU Date Type', { conditionallyRequired: true }),
    col('cubeLevelPerSellableUnit', 'Cube Level Per Sellable Unit', { conditionallyRequired: true }),
    col('customerGuaranteeDays', 'Customer Guarantee Days', { conditionallyRequired: true }),
    col('unitWeightOz', 'Unit Weight (oz)'),
    col('barcode', 'Barcode'),
    col('barcodeType', 'Barcode Type'),
    col('ogCv', 'OG/CV', { conditionallyRequired: true }),
    col('prop65Warning', 'Prop65 Warning'),
    col('prop65Alcohol', 'Prop65 Alcohol Flag'),
    col('prop65Canned', 'Prop65 Canned Flag'),
    col('prop65Food', 'Prop65 Food Flag'),
    col('prop65NonFood', 'Prop65 Non-Food Flag'),
    col('prop65Ingredient', 'Prop65 Ingredient'),
    col('sellOnPoQty', 'Sell On PO Qty'),
    col('expireLifeDays', 'Expire Life Days'),
    col('dbiOnly', 'Fulfillable by DBI Only'),
    col('purchasingCasePackSize', 'Purchasing Case Pack Size'),
    col('packagingUnitSize', 'Packaging Unit Size'),
    col('packagingUnitType', 'Packaging Unit Type'),
    col('mpIndividualUnitSize', 'MP Individual Unit Size'),
    col('mpIndividualUOM', 'MP Individual Unit UOM'),
];
